// DS7.4.1, but only a button.
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink, { Props as BaseButtonProps } from '../../../Buttons/PlainButtonOrLink';
import GhostButton from '../../../Buttons/GhostButton';
import SolidButton from '../../../Buttons/SolidButton';
import s from './BannerButton.scss';

interface Props extends BaseButtonProps {
  variant: 'underline' | 'ghost' | 'solid';
}

/**
 * DS7.4.1, but only a button.
 *
 * A helper component with some typescript guidance to keep our banner buttons somewhat similar. Use this in tandem with other
 * {@link @wix/da-ds/pkg/Banner/lego} components when building a variant of DS7.4.1
 */
const BannerButton: React.FC<Props> = ({ variant, className, children, ...rest }) => {
  switch (variant) {
    case 'solid':
      return (
        <SolidButton
          size="small"
          variant="approval-green"
          priority="primary"
          className={className}
          {...rest}
        >
          {children}
        </SolidButton>
      );
    case 'ghost':
      return (
        <GhostButton size="small" variant="main" className={className} {...rest}>
          {children}
        </GhostButton>
      );
    case 'underline':
    default:
      return (
        <PlainButtonOrLink className={c(s['text-link'], className)} {...rest}>
          {children}
        </PlainButtonOrLink>
      );
  }
};

BannerButton.displayName = 'BannerButton';

export default BannerButton;
